import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getOwnedProducts } from 'self-service-api/api/getProducts';
import * as AdminModalTypes from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { getOwnedHubs } from '../../../utils/getOwnedHubs';
import { getSeatSelectOptions } from '../../../utils/getSeatSelectOptions';
import { fetchAvailableSeats } from '../../api/fetchAvailableSeats';
import { getCanViewNewSeats } from '../../eligibility/getCanViewNewSeats';
import { RequestSeatModal } from './RequestSeatModal';
export const RequestSeatModalWrapper = ({
  modalType,
  handleConfirm,
  onClose,
  showSeatSelector,
  canViewNewSeats,
  requestSeatText,
  setRequestSeatText,
  setRequestedSeat
}) => {
  const [selectableSeatOptions, setSelectableSeatOptions] = useState([]);
  const [canViewNewSeatsState, setCanViewNewSeatsState] = useState(false);

  const setRequestSeatTextHandler = ({
    target
  }) => {
    setRequestSeatText(target.value);
  };

  const setRequestSeatHandler = ({
    target
  }) => {
    setRequestedSeat(target.value);
  };

  useEffect(() => {
    if (canViewNewSeats === undefined) {
      getCanViewNewSeats().then(res => {
        setCanViewNewSeatsState(res);
      }).catch(error => {
        console.error(['Error fetching can view new seats', error]);
        setCanViewNewSeatsState(false);
      });
    } else {
      setCanViewNewSeatsState(canViewNewSeats);
    }
  }, [canViewNewSeats]);
  useEffect(() => {
    if (modalType === AdminModalTypes.REQUEST_SEAT_UPGRADE && canViewNewSeatsState && showSeatSelector) {
      Promise.all([fetchAvailableSeats(), getOwnedProducts()]).then(([seats, products]) => {
        const parsedProducts = getOwnedHubs(products);
        const parsedSeats = getSeatSelectOptions(seats, parsedProducts);
        setSelectableSeatOptions(parsedSeats); // default to the first item in the dropdown

        if (parsedSeats) setRequestedSeat(parsedSeats[0].value);
      }).catch(error => {
        console.error(['Error resolving seats data promise', error]);
      });
    }
  }, [canViewNewSeatsState, modalType, setRequestedSeat, showSeatSelector]);
  return /*#__PURE__*/_jsx(RequestSeatModal, {
    modalType: modalType,
    handleConfirm: handleConfirm,
    onClose: onClose,
    requestSeatText: requestSeatText,
    setRequestSeatText: setRequestSeatTextHandler,
    selectableSeatOptions: selectableSeatOptions,
    setRequestSeatHandler: setRequestSeatHandler,
    showSeatSelector: showSeatSelector
  });
};